module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"menu":"Меню"},"en":{"menu":"Menu"}}')
  delete Component.options._Ctor
}
